import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClientTopbarComponent } from '../client-topbar/client-topbar.component';
import { ClientMenuComponent } from '../client-menu/client-menu.component';
import { ClientConfigService } from '@app/layout/service/client-config/client-config.service';
import { BaseSidebar } from '@app/layout/components/base-sidebar';

@Component({
  selector: '[client-sidebar]',
  imports: [CommonModule, ClientMenuComponent, RouterModule, ClientTopbarComponent],
  templateUrl: './client-sidebar.component.html',
})
export class ClientSidebarComponent extends BaseSidebar {
  private readonly clientConfigService = inject(ClientConfigService);
  public clientConfig = this.clientConfigService.getConfig();
}
